import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/attributecommand
 */

import Command from '@ckeditor/ckeditor5-core/src/command';

/**
 * An extension of the base {@link module:core/command~Command} class, which provides utilities for a command
 * that toggles a single attribute on a text or an element.
 *
 * `AttributeCommand` uses {@link module:engine/model/document~Document#selection}
 * to decide which nodes (if any) should be changed, and applies or removes the attribute from them.
 *
 * The command checks the {@link module:engine/model/model~Model#schema} to decide if it can be enabled
 * for the current selection and to which nodes the attribute can be applied.
 *
 * @extends module:core/command~Command
 */
var AttributeCommand = /*#__PURE__*/function (_Command) {
  _inherits(AttributeCommand, _Command);
  var _super = _createSuper(AttributeCommand);
  /**
   * @param {module:core/editor/editor~Editor} editor
   * @param {String} attributeKey Attribute that will be set by the command.
   */
  function AttributeCommand(editor, attributeKey) {
    var _this;
    _classCallCheck(this, AttributeCommand);
    _this = _super.call(this, editor);

    /**
     * The attribute that will be set by the command.
     *
     * @readonly
     * @member {String}
     */
    _this.attributeKey = attributeKey;

    /**
     * Flag indicating whether the command is active. The command is active when the
     * {@link module:engine/model/selection~Selection#hasAttribute selection has the attribute} which means that:
     *
     * * If the selection is not empty &ndash; That the attribute is set on the first node in the selection that allows this attribute.
     * * If the selection is empty &ndash; That the selection has the attribute itself (which means that newly typed
     * text will have this attribute, too).
     *
     * @observable
     * @readonly
     * @member {Boolean} #value
     */
    return _this;
  }

  /**
   * Updates the command's {@link #value} and {@link #isEnabled} based on the current selection.
   */
  _createClass(AttributeCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.value = this._getValueFromFirstAllowedNode();
      this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }

    /**
     * Executes the command &mdash; applies the attribute to the selection or removes it from the selection.
     *
     * If the command is active (`value == true`), it will remove attributes. Otherwise, it will set attributes.
     *
     * The execution result differs, depending on the {@link module:engine/model/document~Document#selection}:
     *
     * * If the selection is on a range, the command applies the attribute to all nodes in that range
     * (if they are allowed to have this attribute by the {@link module:engine/model/schema~Schema schema}).
     * * If the selection is collapsed in a non-empty node, the command applies the attribute to the
     * {@link module:engine/model/document~Document#selection} itself (note that typed characters copy attributes from the selection).
     * * If the selection is collapsed in an empty node, the command applies the attribute to the parent node of the selection (note
     * that the selection inherits all attributes from a node if it is in an empty node).
     *
     * @fires execute
     * @param {Object} [options] Command options.
     * @param {Boolean} [options.forceValue] If set, it will force the command behavior. If `true`, the command will apply the attribute,
     * otherwise the command will remove the attribute.
     * If not set, the command will look for its current value to decide what it should do.
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var doc = model.document;
      var selection = doc.selection;
      var value = options.forceValue === undefined ? !this.value : options.forceValue;
      model.change(function (writer) {
        if (selection.isCollapsed) {
          if (value) {
            writer.setSelectionAttribute(_this2.attributeKey, true);
          } else {
            writer.removeSelectionAttribute(_this2.attributeKey);
          }
        } else {
          var ranges = model.schema.getValidRanges(selection.getRanges(), _this2.attributeKey);
          var _iterator = _createForOfIteratorHelper(ranges),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var range = _step.value;
              if (value) {
                writer.setAttribute(_this2.attributeKey, value, range);
              } else {
                writer.removeAttribute(_this2.attributeKey, range);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
    }

    /**
     * Checks the attribute value of the first node in the selection that allows the attribute.
     * For the collapsed selection returns the selection attribute.
     *
     * @private
     * @returns {Boolean} The attribute value.
     */
  }, {
    key: "_getValueFromFirstAllowedNode",
    value: function _getValueFromFirstAllowedNode() {
      var model = this.editor.model;
      var schema = model.schema;
      var selection = model.document.selection;
      if (selection.isCollapsed) {
        return selection.hasAttribute(this.attributeKey);
      }
      var _iterator2 = _createForOfIteratorHelper(selection.getRanges()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var range = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(range.getItems()),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;
              if (schema.checkAttribute(item, this.attributeKey)) {
                return item.hasAttribute(this.attributeKey);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }]);
  return AttributeCommand;
}(Command);
export { AttributeCommand as default };